import { openBlock, createElementBlock, createStaticVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [
    createStaticVNode('<g clip-path="url(#clip0_3302_418813)"><path fill="#2E90FA" d="M12.355 2.834a1.5 1.5 0 0 0 .811.812l1.288.533a1.5 1.5 0 0 1 .812 1.96l-.533 1.287a1.5 1.5 0 0 0 0 1.149l.533 1.286a1.5 1.5 0 0 1-.812 1.96l-1.287.534a1.5 1.5 0 0 0-.813.81l-.533 1.289a1.5 1.5 0 0 1-1.96.811l-1.287-.533a1.5 1.5 0 0 0-1.148.001l-1.287.533a1.5 1.5 0 0 1-1.96-.811l-.533-1.289a1.5 1.5 0 0 0-.81-.812l-1.288-.533a1.5 1.5 0 0 1-.813-1.96l.533-1.286a1.5 1.5 0 0 0 0-1.148L.735 6.138a1.5 1.5 0 0 1 .812-1.96l1.287-.533a1.5 1.5 0 0 0 .812-.81l.533-1.288A1.5 1.5 0 0 1 6.14.735l1.287.533a1.5 1.5 0 0 0 1.148 0L9.862.735a1.5 1.5 0 0 1 1.96.812l.534 1.288z"></path><path fill="#fff" fill-rule="evenodd" d="M11.133 5.903a.75.75 0 0 0-1.266-.806L6.93 9.712l-1.344-1.68a.75.75 0 0 0-1.172.937l2 2.5a.75.75 0 0 0 1.22-.066z" clip-rule="evenodd"></path></g><defs><clipPath id="clip0_3302_418813"><path fill="#fff" d="M0 0h16v16H0z"></path></clipPath></defs>', 2)
  ])]);
}
const VerifyTickIcon = { render };
export {
  VerifyTickIcon as default,
  render
};
//# sourceMappingURL=verify-tick.svg.js.map
